// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMediaAudioLoudSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 5v14c0 .866-1.025 1.322-1.669.743L8.59 16.14a.5.5 0 0 0-.347-.14H4.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h3.743a.5.5 0 0 0 .347-.14l3.741-3.603C12.975 3.677 14 4.134 14 5zM18 12c0 1.386-.7 2.553-1.514 2.897-.254.107-.486-.12-.486-.397v-5c0-.276.232-.504.486-.397C17.3 9.447 18 10.613 18 12z"
    />
    <path
      fill="currentColor"
      d="M16 6.25v-.5c0-.276.225-.503.498-.462 1.13.17 2.24.901 3.08 1.923.982 1.192 1.672 2.859 1.672 4.79 0 1.93-.69 3.597-1.671 4.788-.841 1.022-1.951 1.753-3.08 1.923-.274.041-.499-.186-.499-.462v-.5c0-.276.227-.498.494-.567.613-.16 1.315-.603 1.927-1.347.769-.933 1.329-2.266 1.329-3.836 0-1.57-.56-2.902-1.329-3.836-.612-.743-1.314-1.187-1.927-1.347-.267-.07-.494-.29-.494-.567z"
    />
  </svg>
);
export default SvgMediaAudioLoudSolid;
